import { render, staticRenderFns } from "./Subtopic.vue?vue&type=template&id=c8c3abbe"
import script from "./Subtopic.vue?vue&type=script&lang=js"
export * from "./Subtopic.vue?vue&type=script&lang=js"
import style0 from "./Subtopic.vue?vue&type=style&index=0&id=c8c3abbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports